import Phaser from 'phaser';
import { sounds } from '../audio/SoundEffects';
import { VirtualControls } from '../ui/VirtualControls';
import { progression } from '../game/Progression';

export class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameScene' });
  }

  init(data) {
    this.currentLevel = data.level || 1;
    this.isLevel2 = this.currentLevel === 2;
    this.isLevel3 = this.currentLevel === 3;
    this.isLevel4 = this.currentLevel === 4;
    this.isLevel5 = this.currentLevel === 5;
    this.isLevel6 = this.currentLevel === 6;
    this.isLevel7 = this.currentLevel === 7;
    this.isLevel8 = this.currentLevel === 8;
    this.isLevel9 = this.currentLevel === 9;
    this.isLevel10 = this.currentLevel === 10;
    this.isLevel11 = this.currentLevel === 11;

    this.carryOverScore = Math.max(0, parseInt(data.score, 10) || 0);
    this.carryOverVinyls = Math.max(0, parseInt(data.vinyls, 10) || 0);

    const levelConfigs = {
      1: {
        title: 'STAGE 1: OLYMPUS',
        color: '#38bdf8',
        hexColor: 0x38bdf8,
        bgKey: 'olympus_bg',
        track: 'olympus',
        moveSpeed: 230,
        autoSpeed: 195,
        goalDistance: 2600,
        platformTex: 'platform_marble',
        movingTex: 'platform_cloud',
        spikeTex: 'hazard_spike',
        eventTitle: '⚡ ZEUS THUNDER STORM! EVADE! ⚡'
      },
      2: {
        title: 'STAGE 2: TARTARUS',
        color: '#c026d3',
        hexColor: 0xc026d3,
        bgKey: 'tartarus_bg',
        track: 'tartarus',
        moveSpeed: 255,
        autoSpeed: 220,
        goalDistance: 3300,
        platformTex: 'platform_tartarus',
        movingTex: 'platform_electric',
        spikeTex: 'hazard_tartarus_spike',
        eventTitle: '⚡ TARTARUS LASER STORM! EVADE! ⚡'
      },
      3: {
        title: 'STAGE 3: CYBER FORGE',
        color: '#f97316',
        hexColor: 0xf97316,
        bgKey: 'hephaestus_bg',
        track: 'hephaestus',
        moveSpeed: 275,
        autoSpeed: 240,
        goalDistance: 3900,
        platformTex: 'platform_bronze',
        movingTex: 'platform_magma',
        spikeTex: 'hazard_forge_spike',
        eventTitle: '🔥 HEPHAESTUS MAGMA SURGE! EVADE! 🔥'
      },
      4: {
        title: 'STAGE 4: COSMOS',
        color: '#e879f9',
        hexColor: 0xe879f9,
        bgKey: 'cosmic_bg',
        track: 'cosmic',
        moveSpeed: 295,
        autoSpeed: 255,
        goalDistance: 4600,
        platformTex: 'platform_cosmic',
        movingTex: 'platform_nebula',
        spikeTex: 'hazard_cosmic_spike',
        eventTitle: '🌌 COSMIC SUPERNOVA FLARE! EVADE! 🌌'
      },
      5: {
        title: 'STAGE 5: ATLANTIS',
        color: '#06b6d4',
        hexColor: 0x06b6d4,
        bgKey: 'atlantis_bg',
        track: 'atlantis',
        moveSpeed: 305,
        autoSpeed: 265,
        goalDistance: 5200,
        platformTex: 'platform_coral',
        movingTex: 'platform_hydro',
        spikeTex: 'hazard_coral_spike',
        eventTitle: '🌊 POSEIDON TIDAL SURGE! EVADE! 🌊'
      },
      6: {
        title: 'STAGE 6: DIONYSUS',
        color: '#d946ef',
        hexColor: 0xd946ef,
        bgKey: 'dionysus_bg',
        track: 'dionysus',
        moveSpeed: 320,
        autoSpeed: 280,
        goalDistance: 5800,
        platformTex: 'platform_grape',
        movingTex: 'platform_goldrave',
        spikeTex: 'hazard_rave_spike',
        eventTitle: '⚡ BACCHIC STROBE FRENZY! EVADE! ⚡'
      },
      7: {
        title: 'STAGE 7: ARES CITADEL',
        color: '#ef4444',
        hexColor: 0xef4444,
        bgKey: 'ares_bg',
        track: 'ares',
        moveSpeed: 335,
        autoSpeed: 295,
        goalDistance: 6400,
        platformTex: 'platform_titanium',
        movingTex: 'platform_plasma',
        spikeTex: 'hazard_ares_spike',
        eventTitle: '🔥 ARES ORBITAL BARRAGE! EVADE! 🔥'
      },
      8: {
        title: 'STAGE 8: KRONOS',
        color: '#facc15',
        hexColor: 0xfacc15,
        bgKey: 'chronos_bg',
        track: 'chronos',
        moveSpeed: 350,
        autoSpeed: 310,
        goalDistance: 7000,
        platformTex: 'platform_chronos',
        movingTex: 'platform_rift',
        spikeTex: 'hazard_chronos_spike',
        eventTitle: '⌛ TEMPORAL SINGULARITY COLLAPSE! ⌛'
      },
      9: {
        title: 'STAGE 9: RIVER STYX',
        color: '#10b981',
        hexColor: 0x10b981,
        bgKey: 'styx_bg',
        track: 'styx',
        moveSpeed: 365,
        autoSpeed: 325,
        goalDistance: 7600,
        platformTex: 'platform_styx',
        movingTex: 'platform_ferry',
        spikeTex: 'hazard_styx_spike',
        eventTitle: '💀 STYX SOUL HARVEST VORTEX! EVADE! 💀'
      },
      10: {
        title: 'STAGE 10: APOLLO HYPER-DRIVE',
        color: '#f59e0b',
        hexColor: 0xf59e0b,
        bgKey: 'apollo_bg',
        track: 'apollo',
        moveSpeed: 380,
        autoSpeed: 340,
        goalDistance: 8200,
        platformTex: 'platform_solar',
        movingTex: 'platform_sunspot',
        spikeTex: 'hazard_solar_spike',
        eventTitle: '☀️ APOLLO CORONAL MASS EJECTION! EVADE! ☀️'
      },
      11: {
        title: 'STAGE 11: CHAOS GENESIS',
        color: '#a855f7',
        hexColor: 0xa855f7,
        bgKey: 'chaos_bg',
        track: 'chaos',
        moveSpeed: 395,
        autoSpeed: 355,
        goalDistance: 9000,
        platformTex: 'platform_chaos',
        movingTex: 'platform_genesis',
        spikeTex: 'hazard_chaos_spike',
        eventTitle: '🌌 PRIMORDIAL BIG BANG SINGULARITY! EVADE! 🌌'
      }
    };

    this.cfg = levelConfigs[this.currentLevel] || levelConfigs[1];
  }

  create() {
    // 1. GAME CONSTANTS & STATE
    this.GRAVITY_STRENGTH = 1350;
    this.MOVE_SPEED = this.cfg.moveSpeed;
    this.AUTO_FORWARD_SPEED = this.cfg.autoSpeed;
    this.GOAL_DISTANCE = this.cfg.goalDistance;

    // Health / Lives System (3 Hearts so player doesn't instantly die on first scratch)
    this.maxLives = 3;
    this.lives = 3;

    this.isGravityInverted = false;
    this.canFlipGravity = true;
    this.flipCooldownTime = 240; // ms
    this.score = this.carryOverScore || 0;
    this.vinylsCount = this.carryOverVinyls || 0;
    this.isGameOver = false;
    this.isLevelCompleted = false;
    this.portalSpawned = false;

    // Metagame Perks & Progression
    this.hasShield = progression.hasPerk('perk_shield');
    this.hasMagnet = progression.hasPerk('perk_magnet');
    this.hasFuel = progression.hasPerk('perk_fuel');
    this.hasMidas = progression.hasPerk('perk_midas');

    // Overdrive Frenzy State
    this.overdriveMeter = 0; // 0..100%
    this.isOverdrive = false;
    this.overdriveTimer = 0;
    this.isDamageGrace = false;

    // Combo Multiplier State
    this.comboMultiplier = 1;
    this.comboTimer = 0;

    // Missions & Run Stats
    this.slideCount = 0;
    this.flipCount = 0;
    this.closeCallCount = 0;

    // Zeus Thunder Storm Event State
    this.stormTriggered = false;
    this.stormActive = false;
    this.stormStrikesRemaining = 0;
    this.nextStrikeTime = 0;

    // World bounds setup (Portrait height: 854, Width: infinite)
    const { width, height } = this.scale;
    this.ceilingY = 75;
    this.floorY = height - 155;

    // Set world gravity initially downward (normal)
    this.physics.world.gravity.y = this.GRAVITY_STRENGTH;

    // 2. BACKGROUND (Generated Level Art with Parallax)
    this.createBackground(width, height);

    // 3. PHYSICS GROUPS
    this.platforms = this.physics.add.staticGroup();
    this.movingPlatforms = this.physics.add.group({ allowGravity: false, immovable: true });
    this.hazards = this.physics.add.group({ allowGravity: false, immovable: true });
    this.collectibles = this.physics.add.group({ allowGravity: false });
    this.portalGroup = this.physics.add.group({ allowGravity: false, immovable: true });

    // 4. PLAYER CREATION (Zelvis)
    this.createPlayer();

    // Player state tracking for animations and physics
    this.isSliding = false;
    this.isSkidding = false;
    this.slideTimer = 0;
    this.skidSoundCooldown = 0;

    // 5. PARTICLE EMITTERS
    this.createParticles();

    // 6. PROCEDURAL WORLD GENERATION
    this.chunkWidth = 500;
    this.lastGeneratedX = 0;
    this.generateInitialRunway();
    for (let i = 0; i < 4; i++) {
      this.generateChunk();
    }

    // 7. CAMERA SETUP
    this.cameras.main.startFollow(this.player, true, 0.1, 0.05, -120, 0);
    this.cameras.main.setBounds(0, 0, Number.MAX_SAFE_INTEGER, height);

    // 8. COLLISION DETECTION & PHYSICS RESOLUTION
    this.setupCollisions();

    // 9. MOBILE VIRTUAL CONTROLS
    this.virtualControls = new VirtualControls(this);
    this.virtualControls.setAntiGravityCallback(() => this.toggleAntiGravity());

    // 10. HUD DISPLAY (Fixed to screen)
    this.createHUD(width);

    // 11. START DYNAMIC ROCK MUSIC
    sounds.music.play(this.cfg.track);

    // Camera ready immediately without dark veil
    // this.cameras.main.fadeIn(300, 0, 0, 0);

    // Welcoming banner if points carried over from previous stage
    if (this.carryOverScore > 0) {
      this.time.delayedCall(450, () => {
        if (!this.isGameOver && !this.isLevelCompleted && this.player) {
          this.showFloatingText(
            this.player.x + 80,
            this.player.y - 75,
            `⚡ RUN TOTAL: ${this.score} PTS! ⚡`,
            '#fde047',
            '22px'
          );
        }
      });
    }
  }

  // =========================================================================
  // BACKGROUND SETUP WITH GENERATED ART & PARALLAX
  // =========================================================================
  createBackground(width, height) {
    const bgKey = this.cfg.bgKey;

    if (this.textures.exists(bgKey)) {
      this.bgImage = this.add.image(width / 2, height / 2, bgKey)
        .setScrollFactor(0)
        .setAlpha(0.92);
      const scaleX = width / this.bgImage.width;
      const scaleY = height / this.bgImage.height;
      this.bgImage.setScale(Math.max(scaleX, scaleY));
    } else {
      // Fallback procedural gradient
      const bgGrad = this.add.graphics().setScrollFactor(0);
      let topColor = 0x0f172a, botColor = 0x1e1b4b;
      if (this.isLevel2) { topColor = 0x2e0854; botColor = 0x090014; }
      else if (this.isLevel3) { topColor = 0x451a03; botColor = 0x1c0902; }
      else if (this.isLevel4) { topColor = 0x1e1b4b; botColor = 0x030014; }
      else if (this.isLevel5) { topColor = 0x083344; botColor = 0x021720; }
      else if (this.isLevel6) { topColor = 0x3b0764; botColor = 0x1a022e; }
      else if (this.isLevel7) { topColor = 0x450a0a; botColor = 0x1f0303; }
      else if (this.isLevel8) { topColor = 0x422006; botColor = 0x1a0b02; }
      else if (this.isLevel9) { topColor = 0x022c22; botColor = 0x01130e; }
      else if (this.isLevel10) { topColor = 0x451a03; botColor = 0x1c0a02; }
      else if (this.isLevel11) { topColor = 0x2e1065; botColor = 0x0a0118; }
      bgGrad.fillGradientStyle(topColor, topColor, botColor, botColor, 1);
      bgGrad.fillRect(0, 0, width, height);
    }

    // Distant pillars for extra parallax depth
    this.parallaxDistant = this.add.graphics().setScrollFactor(0.25);
    let pillarColor = 0x312e81;
    if (this.isLevel2) pillarColor = 0x581c87;
    else if (this.isLevel3) pillarColor = 0x78350f;
    else if (this.isLevel4) pillarColor = 0x4c1d95;
    else if (this.isLevel5) pillarColor = 0x0e7490;
    else if (this.isLevel6) pillarColor = 0x86198f;
    else if (this.isLevel7) pillarColor = 0x991b1b;
    else if (this.isLevel8) pillarColor = 0x854d0e;
    else if (this.isLevel9) pillarColor = 0x065f46;
    else if (this.isLevel10) pillarColor = 0xb45309;
    else if (this.isLevel11) pillarColor = 0x6b21a8;
    this.parallaxDistant.fillStyle(pillarColor, 0.35);
    for (let x = 0; x < 6000; x += 190) {
      this.parallaxDistant.fillRect(x, 110, 34, height - 260);
    }
  }

  // =========================================================================
  // PLAYER SETUP
  // =========================================================================
  createPlayer() {
    // Spawn safely above the floor so initial frame physics resolves perfectly
    this.player = this.physics.add.sprite(180, this.floorY - 60, 'zelvis_idle');
    this.player.setScale(0.38);
    this.player.setCollideWorldBounds(false);
    this.player.setBounce(0.0);
    this.player.setMaxVelocity(600, 650);
    this.player.setSize(80, 215);
    this.player.setOffset(88, 25);
    this.player.setDepth(20);
    this.player.play('run');

    // Aegis Shield Forcefield Aura (if perk unlocked)
    if (this.hasShield) {
      this.shieldSprite = this.add.image(this.player.x, this.player.y, 'shield_aura')
        .setDepth(22)
        .setScale(0.95)
        .setAlpha(0.85);
      this.tweens.add({
        targets: this.shieldSprite,
        angle: 360,
        scaleX: 1.08,
        scaleY: 1.08,
        duration: 2200,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    }
  }

  // Robust floor platform with 160px deep foundation (prevents all tunneling)
  createFloorPlatform(x, tex) {
    const p = this.platforms.create(x, this.floorY, tex);
    p.setSize(120, 160);
    p.setOffset(0, 0);
    p.refreshBody();
    p.setDepth(10);
    return p;
  }

  // Robust ceiling platform with 160px deep ceiling foundation (prevents tunneling in anti-gravity)
  createCeilingPlatform(x, tex) {
    const p = this.platforms.create(x, this.ceilingY, tex);
    p.setSize(120, 160);
    p.setOffset(0, -124);
    p.refreshBody();
    p.setDepth(10);
    return p;
  }

  // =========================================================================
  // PARTICLE EMITTERS
  // =========================================================================
  createParticles() {
    this.sparkEmitter = this.add.particles(0, 0, 'particle_star', {
      lifespan: 400,
      speed: { min: 80, max: 220 },
      scale: { start: 1, end: 0 },
      blendMode: 'ADD',
      emitting: false
    }).setDepth(25);

    this.noteEmitter = this.add.particles(0, 0, 'particle_note', {
      lifespan: 600,
      speed: { min: 60, max: 180 },
      scale: { start: 1.2, end: 0.2 },
      alpha: { start: 1, end: 0 },
      emitting: false
    }).setDepth(25);

    // Friction smoke for rockstar slide and braking
    this.smokeEmitter = this.add.particles(0, 0, 'particle_smoke', {
      lifespan: 450,
      speed: { min: 40, max: 120 },
      scale: { start: 1.2, end: 0.1 },
      alpha: { start: 0.8, end: 0 },
      emitting: false
    }).setDepth(24);

    // Electric Overdrive Lightning particles
    this.lightningEmitter = this.add.particles(0, 0, 'particle_lightning', {
      lifespan: 380,
      speed: { min: 90, max: 240 },
      scale: { start: 1.1, end: 0.1 },
      blendMode: 'ADD',
      emitting: false
    }).setDepth(26);
  }

  // =========================================================================
  // PROCEDURAL WORLD GENERATION
  // =========================================================================
  generateInitialRunway() {
    const platformTex = this.cfg.platformTex;
    // Generates a generous safe starting runway with plenty of vinyls
    for (let x = 0; x < 1200; x += 120) {
      this.createCeilingPlatform(x + 60, platformTex);
      this.createFloorPlatform(x + 60, platformTex);

      // Welcoming strings of Golden Vinyls right from start!
      if (x >= 240 && x < 1080) {
        if (x % 240 === 0) {
          this.createCoin(x + 30, this.floorY - 45);
          this.createCoin(x + 75, this.floorY - 45);
          this.createCoin(x + 120, this.floorY - 45);
        } else if (x === 600 || x === 960) {
          const bolt = this.collectibles.create(x + 60, (this.floorY + this.ceilingY) / 2, 'item_lightning');
          bolt.isBonus = true;
          this.tweens.add({
            targets: bolt,
            scale: 1.2,
            duration: 450,
            yoyo: true,
            repeat: -1
          });
        }
      }
    }
    this.lastGeneratedX = 1200;
  }

  generateChunk() {
    const startX = this.lastGeneratedX;
    const endX = startX + this.chunkWidth;
    const platformTex = this.cfg.platformTex;
    const spikeTex = this.cfg.spikeTex;
    const movingTex = this.cfg.movingTex;

    // Check if goal reached -> Spawn finish portal runway
    if (startX >= this.GOAL_DISTANCE && !this.portalSpawned) {
      this.generateFinishPortal(startX);
      this.lastGeneratedX = endX + 800;
      return;
    }

    // 1. Base floor & ceiling platforms (Fair and rhythmic obstacle balance)
    for (let x = startX; x < endX; x += 120) {
      // Predictable occasional tactical gaps
      const skipFloor = Math.random() < 0.10 && x > 1400;
      const skipCeiling = !skipFloor && Math.random() < 0.10 && x > 1400;

      if (!skipCeiling) {
        this.createCeilingPlatform(x + 60, platformTex);
        // Fair ceiling spike hazard
        if (Math.random() < 0.14) {
          const spike = this.hazards.create(x + 60, this.ceilingY + 28, spikeTex);
          spike.setFlipY(true);
          spike.setSize(32, 36);
          spike.setOffset(2, 4);
          spike.setDepth(15);
        } else if (Math.random() < 0.65) {
          // Generous Golden Vinyl on ceiling!
          this.createCoin(x + 60, this.ceilingY + 45);
        }
      }

      if (!skipFloor) {
        this.createFloorPlatform(x + 60, platformTex);
        // Fair floor spike hazard
        if (Math.random() < 0.14) {
          const spike = this.hazards.create(x + 60, this.floorY - 28, spikeTex);
          spike.setSize(32, 36);
          spike.setOffset(2, 2);
          spike.setDepth(15);
        } else if (Math.random() < 0.65) {
          // Generous Golden Vinyl on floor!
          this.createCoin(x + 60, this.floorY - 45);
        }
      }
    }

    // 2. Mid-air floating platforms
    const midY = (this.ceilingY + this.floorY) / 2;
    const numPlatforms = Phaser.Math.Between(1, this.currentLevel >= 2 ? 3 : 2);
    for (let p = 0; p < numPlatforms; p++) {
      const px = startX + Phaser.Math.Between(50, this.chunkWidth - 100);
      const py = midY + Phaser.Math.Between(-120, 120);
      const isMoving = Math.random() < (this.currentLevel >= 2 ? 0.45 : 0.35);

      if (isMoving) {
        const mp = this.movingPlatforms.create(px, py, movingTex);
        mp.body.setImmovable(true);
        mp.body.allowGravity = false;
        mp.setSize(130, 42);
        mp.setDepth(12);
        mp.minY = py - 70;
        mp.maxY = py + 70;
        mp.moveSpeed = Phaser.Math.Between(50, 80);
        mp.body.setVelocityY(mp.moveSpeed);
      } else {
        const sp = this.platforms.create(px, py, platformTex);
        sp.setSize(120, 42);
        sp.refreshBody();
        sp.setDepth(12);
      }

      // Chain of vinyls on mid-air platforms!
      this.createCoin(px - 20, py - 40);
      this.createCoin(px + 25, py - 40);
    }

    // 3. Floating Hazards (Antimatter, Sunflares, Wraiths, Pendulums, Mines, Speakers, Jellyfish, Saws, Supernovas, Lasers, Orbs)
    if (this.isLevel11 && Math.random() < 0.48) {
      // Primordial Chaos Antimatter Singularity Core
      const cx = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const cy = midY + Phaser.Math.Between(-85, 85);
      const antimatter = this.hazards.create(cx, cy, 'hazard_antimatter');
      antimatter.setCircle(20, 2, 2);
      this.tweens.add({
        targets: antimatter,
        angle: 360,
        duration: 700,
        repeat: -1
      });
      this.tweens.add({
        targets: antimatter,
        scale: 1.3,
        duration: 380,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
      this.tweens.add({
        targets: antimatter,
        y: cy + 80,
        duration: 1050,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel10 && Math.random() < 0.45) {
      // Apollo Solar Flare Corona
      const fx = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const fy = midY + Phaser.Math.Between(-80, 80);
      const flare = this.hazards.create(fx, fy, 'hazard_sunflare');
      flare.setCircle(20, 2, 2);
      this.tweens.add({
        targets: flare,
        angle: -360,
        duration: 850,
        repeat: -1
      });
      this.tweens.add({
        targets: flare,
        y: fy + 80,
        duration: 1150,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel9 && Math.random() < 0.42) {
      // River Styx Spectral Wraith
      const gx = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const gy = midY + Phaser.Math.Between(-85, 85);
      const ghost = this.hazards.create(gx, gy, 'hazard_ghost');
      ghost.setSize(36, 40);
      ghost.setOffset(4, 2);
      this.tweens.add({
        targets: ghost,
        y: gy + 75,
        duration: 1300,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
      this.tweens.add({
        targets: ghost,
        alpha: 0.55,
        duration: 480,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel8 && Math.random() < 0.45) {
      // Golden Pendulum Scythe of Chronos
      const px = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const py = midY + Phaser.Math.Between(-80, 80);
      const pendulum = this.hazards.create(px, py, 'hazard_pendulum');
      pendulum.setCircle(20, 2, 2);
      this.tweens.add({
        targets: pendulum,
        angle: 360,
        duration: 900,
        repeat: -1
      });
      this.tweens.add({
        targets: pendulum,
        y: py + 85,
        duration: 1100,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel7 && Math.random() < 0.42) {
      // Ares Spiked Orbital Mine
      const mx = startX + Phaser.Math.Between(110, this.chunkWidth - 90);
      const my = midY + Phaser.Math.Between(-85, 85);
      const mine = this.hazards.create(mx, my, 'hazard_mine');
      mine.setCircle(20, 2, 2);
      this.tweens.add({
        targets: mine,
        scale: 1.25,
        duration: 400,
        yoyo: true,
        repeat: -1
      });
      this.tweens.add({
        targets: mine,
        y: my + 75,
        duration: 1250,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel6 && Math.random() < 0.4) {
      // Dionysus Bass Soundwave Speaker
      const spx = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const spy = midY + Phaser.Math.Between(-75, 75);
      const speaker = this.hazards.create(spx, spy, 'hazard_speaker');
      speaker.setSize(38, 38);
      speaker.setOffset(3, 3);
      this.tweens.add({
        targets: speaker,
        scaleX: 1.22,
        scaleY: 1.22,
        duration: 380,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel5 && Math.random() < 0.4) {
      // Atlantis Bioluminescent Jellyfish
      const jx = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const jy = midY + Phaser.Math.Between(-90, 90);
      const jelly = this.hazards.create(jx, jy, 'hazard_jellyfish');
      jelly.setSize(34, 38);
      jelly.setOffset(4, 2);
      this.tweens.add({
        targets: jelly,
        y: jy + 80,
        duration: 1400,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
      this.tweens.add({
        targets: jelly,
        scaleY: 0.85,
        duration: 700,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel3 && Math.random() < 0.38) {
      // Rotating Industrial Saw Blade
      const sx = startX + Phaser.Math.Between(110, this.chunkWidth - 90);
      const sy = midY + Phaser.Math.Between(-80, 80);
      const saw = this.hazards.create(sx, sy, 'hazard_saw');
      saw.setCircle(20, 2, 2);
      this.tweens.add({
        targets: saw,
        angle: 360,
        duration: 800,
        repeat: -1
      });
      this.tweens.add({
        targets: saw,
        y: sy + 70,
        duration: 1200,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel4 && Math.random() < 0.4) {
      // Pulsar Supernova Orb
      const ox = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const oy = midY + Phaser.Math.Between(-90, 90);
      const nova = this.hazards.create(ox, oy, 'hazard_supernova');
      nova.setCircle(18, 2, 2);
      this.tweens.add({
        targets: nova,
        scale: 1.25,
        duration: 500,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
      this.tweens.add({
        targets: nova,
        y: oy + 80,
        duration: 1300,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    } else if (this.isLevel2 && Math.random() < 0.35) {
      // Laser Barrier
      const lx = startX + Phaser.Math.Between(120, this.chunkWidth - 90);
      const ly = midY + Phaser.Math.Between(-60, 60);
      const laser = this.hazards.create(lx, ly, 'hazard_laser');
      laser.setSize(20, 66);
      laser.setOffset(2, 2);

      this.tweens.add({
        targets: laser,
        alpha: 0.4,
        duration: 350,
        yoyo: true,
        repeat: -1
      });
    } else if (Math.random() < 0.35) {
      // Plasma Orb
      const orbX = startX + Phaser.Math.Between(100, this.chunkWidth - 80);
      const orbY = midY + Phaser.Math.Between(-100, 100);
      const orb = this.hazards.create(orbX, orbY, 'hazard_orb');
      orb.setCircle(17, 2, 2);

      this.tweens.add({
        targets: orb,
        y: orbY + 80,
        duration: 1400,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    }

    // 4. Frequent Bonus Zeus Lightning bolts
    if (Math.random() < 0.6) {
      const boltX = startX + Phaser.Math.Between(100, this.chunkWidth - 60);
      const boltY = midY + Phaser.Math.Between(-80, 80);
      const bolt = this.collectibles.create(boltX, boltY, 'item_lightning');
      bolt.isBonus = true;
      this.tweens.add({
        targets: bolt,
        scale: 1.18,
        duration: 500,
        yoyo: true,
        repeat: -1
      });
    }

    this.lastGeneratedX = endX;
  }

  generateFinishPortal(x) {
    this.portalSpawned = true;
    const platformTex = this.cfg.platformTex;

    // Safe runway for finish portal
    for (let px = x; px < x + 600; px += 120) {
      this.createCeilingPlatform(px + 60, platformTex);
      this.createFloorPlatform(px + 60, platformTex);
    }

    // Finish Portal
    const portalX = x + 350;
    const portalY = (this.ceilingY + this.floorY) / 2;
    const portal = this.portalGroup.create(portalX, portalY, 'portal_finish');
    portal.setSize(50, 110);
    portal.setOffset(15, 15);

    // Glowing pulsation
    this.tweens.add({
      targets: portal,
      scaleX: 1.12,
      scaleY: 1.12,
      duration: 600,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });

    // Portal signage
    const label = this.add.text(portalX, portalY - 90, '⚡ STAGE CLEAR ⚡', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '20px',
      color: '#facc15',
      stroke: '#000000',
      strokeThickness: 4
    }).setOrigin(0.5);
  }

  createCoin(x, y) {
    const coin = this.collectibles.create(x, y, 'item_vinyl');
    coin.isBonus = false;
    this.tweens.add({
      targets: coin,
      y: y - 10,
      duration: 800,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });
  }

  // =========================================================================
  // ANTI-GRAVITY INVERSION MECHANIC
  // =========================================================================
  toggleAntiGravity() {
    if (this.isGameOver || this.isLevelCompleted || !this.canFlipGravity) return;

    this.isGravityInverted = !this.isGravityInverted;
    this.physics.world.gravity.y = this.isGravityInverted ? -this.GRAVITY_STRENGTH : this.GRAVITY_STRENGTH;

    this.canFlipGravity = false;
    this.time.delayedCall(this.flipCooldownTime, () => {
      this.canFlipGravity = true;
    });

    this.player.setFlipY(this.isGravityInverted);

    const impulse = this.isGravityInverted ? -390 : 390;
    this.player.setVelocityY(impulse);

    sounds.playGravityFlip(this.isGravityInverted);

    // Track Mission: Anti-Gravity King
    this.flipCount++;
    if (this.flipCount >= 6) {
      if (progression.claimMission('gravity_maestro')) {
        this.showFloatingText(this.player.x, this.player.y - 50, '🏆 MISSION CLEAR: GRAVITY KING!', '#22c55e', '20px');
      }
    }

    this.cameras.main.shake(120, 0.007);
    this.cameras.main.flash(80, 56, 189, 248);

    this.sparkEmitter.explode(18, this.player.x, this.player.y);
    this.updateGravityHUD();
  }

  // =========================================================================
  // COLLISIONS & TRIGGERS
  // =========================================================================
  setupCollisions() {
    this.physics.add.collider(this.player, this.platforms);
    this.physics.add.collider(this.player, this.movingPlatforms);

    // Hazard hit: Overdrive shred or Shield absorb or Take Damage (3 Lives system)
    this.physics.add.overlap(this.player, this.hazards, (player, hazard) => {
      if (!hazard.active || this.isGameOver || this.isLevelCompleted) return;
      if (this.isDamageGrace) return;

      if (this.isOverdrive) {
        this.destroyHazardInOverdrive(hazard);
      } else if (this.hasShield) {
        this.absorbHitWithShield(hazard);
      } else {
        this.takeDamage(hazard);
      }
    });

    // Collectibles
    this.physics.add.overlap(this.player, this.collectibles, (player, item) => {
      this.collectItem(item);
    });

    // Portal reach
    this.physics.add.overlap(this.player, this.portalGroup, () => {
      this.handleStageComplete();
    });
  }

  // Floating Arcade Score Popups
  showFloatingText(x, y, text, color = '#facc15', fontSize = '20px') {
    const popup = this.add.text(x, y, text, {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize,
      color,
      stroke: '#000000',
      strokeThickness: 4
    }).setOrigin(0.5).setDepth(85);

    this.tweens.add({
      targets: popup,
      y: y - 55,
      scaleX: 1.25,
      scaleY: 1.25,
      alpha: 0,
      duration: 850,
      ease: 'Back.easeOut',
      onComplete: () => popup.destroy()
    });
  }

  // Combo Multiplier Increments
  increaseCombo() {
    this.comboTimer = 3500; // 3.5s refresh
    if (this.comboMultiplier < 5) {
      this.comboMultiplier += 1;
      this.updateHUDText();
    }
  }

  // Hyper Overdrive Fever Mode Activation
  activateOverdrive() {
    if (this.isOverdrive) return;
    this.isOverdrive = true;
    this.overdriveMeter = 100;
    this.overdriveTimer = this.hasFuel ? 7000 : 5000;

    sounds.playOverdriveStart();
    this.cameras.main.flash(400, 250, 204, 21);
    this.cameras.main.shake(250, 0.015);

    this.showFloatingText(this.player.x, this.player.y - 70, '⚡ HYPER OVERDRIVE! 3X ⚡', '#fde047', '26px');
    this.lightningEmitter.explode(30, this.player.x, this.player.y);
    this.updateHUDText();
  }

  // Destroy hazard while in Overdrive
  destroyHazardInOverdrive(hazard) {
    sounds.playRockChord();
    this.cameras.main.shake(180, 0.012);
    this.sparkEmitter.explode(25, hazard.x, hazard.y);
    this.lightningEmitter.explode(20, hazard.x, hazard.y);

    const bonusPoints = 300 * this.comboMultiplier * 3;
    this.score += bonusPoints;
    this.increaseCombo();

    this.showFloatingText(hazard.x, hazard.y - 20, `💥 SHRED! +${bonusPoints}`, '#f43f5e', '22px');
    hazard.destroy();
  }

  // Aegis Shield absorbs lethal blow
  absorbHitWithShield(hazard) {
    this.hasShield = false;
    if (this.shieldSprite) {
      this.shieldSprite.destroy();
      this.shieldSprite = null;
    }

    sounds.playShieldBreak();
    this.cameras.main.flash(300, 56, 189, 248);
    this.cameras.main.shake(200, 0.015);
    this.sparkEmitter.explode(40, this.player.x, this.player.y);

    this.showFloatingText(this.player.x, this.player.y - 50, '🛡️ SHIELD SAVED YOU!', '#38bdf8', '24px');
    if (hazard && hazard.active) {
      hazard.destroy();
    }

    // Invulnerability grace period (0.75 seconds)
    this.isDamageGrace = true;
    this.tweens.add({
      targets: this.player,
      alpha: 0.35,
      duration: 90,
      yoyo: true,
      repeat: 4,
      onComplete: () => {
        if (this.player && this.player.active) {
          this.player.alpha = 1;
        }
        this.isDamageGrace = false;
      }
    });
    this.updateHUDText();
  }

  // Take damage: 3 Lives System (Heart damage with invulnerability grace period)
  takeDamage(hazard) {
    if (this.isDamageGrace || this.isGameOver || this.isLevelCompleted) return;

    this.lives = Math.max(0, this.lives - 1);
    sounds.playCrash();
    this.cameras.main.shake(280, 0.02);
    this.cameras.main.flash(260, 239, 68, 68);
    this.sparkEmitter.explode(35, this.player.x, this.player.y);

    if (hazard && hazard.active) {
      hazard.destroy();
    }

    this.updateHUDText();

    if (this.lives <= 0) {
      this.handleGameOver();
      return;
    }

    // Grace period of invulnerability (0.75 seconds)
    this.isDamageGrace = true;
    const heartsLeft = '❤️'.repeat(this.lives);
    this.showFloatingText(this.player.x, this.player.y - 50, `💔 -1 HP! ${heartsLeft}`, '#f43f5e', '24px');

    this.tweens.add({
      targets: this.player,
      alpha: 0.35,
      duration: 90,
      yoyo: true,
      repeat: 4,
      onComplete: () => {
        if (this.player && this.player.active) {
          this.player.alpha = 1;
        }
        this.isDamageGrace = false;
      }
    });
  }

  collectItem(item) {
    if (!item.active) return;

    let points = 0;
    const multi = this.comboMultiplier * (this.isOverdrive ? 3 : 1);

    if (item.isBonus) {
      points = 250 * multi;
      if (this.hasMidas) points *= 2;
      this.score += points;

      // Balanced charge: +18% (+25% with Fuel perk) so 5-6 bolts fill the gauge
      const charge = this.hasFuel ? 25 : 18;
      this.overdriveMeter = Math.min(100, this.overdriveMeter + charge);

      sounds.playRockChord();
      this.noteEmitter.explode(16, item.x, item.y);
      this.showFloatingText(item.x, item.y, `⚡ +${points}`, '#fde047', '20px');
    } else {
      points = 50 * multi;
      if (this.hasMidas) points *= 2;
      this.score += points;

      const gain = this.hasMidas ? 2 : 1;
      this.vinylsCount += gain;

      // Balanced charge: +4% (+6% with Fuel perk)
      const charge = this.hasFuel ? 6 : 4;
      this.overdriveMeter = Math.min(100, this.overdriveMeter + charge);

      sounds.playCoin();
      this.sparkEmitter.explode(10, item.x, item.y);
      this.showFloatingText(item.x, item.y, `+${points}`, '#38bdf8', '17px');
    }

    this.increaseCombo();

    if (this.overdriveMeter >= 100 && !this.isOverdrive) {
      this.activateOverdrive();
    }

    this.updateHUDText();
    item.destroy();
  }

  // =========================================================================
  // ZEUS THUNDER STORM SURVIVAL EVENT
  // =========================================================================
  startZeusThunderStorm() {
    this.stormTriggered = true;
    this.stormActive = true;
    this.stormStrikesRemaining = 4;

    sounds.playThunder();
    this.cameras.main.flash(300, 245, 158, 11);

    const alertText = this.add.text(this.scale.width / 2, 130, this.cfg.eventTitle, {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '22px',
      color: '#ef4444',
      stroke: '#000000',
      strokeThickness: 5
    }).setOrigin(0.5).setScrollFactor(0).setDepth(90);

    this.tweens.add({
      targets: alertText,
      scaleX: 1.15,
      scaleY: 1.15,
      duration: 350,
      yoyo: true,
      repeat: 4,
      onComplete: () => {
        if (alertText && alertText.active) alertText.destroy();
      }
    });

    this.scheduleNextStormStrike();
  }

  scheduleNextStormStrike() {
    if (!this.sys || !this.scene || this.isGameOver || this.isLevelCompleted) return;

    if (this.stormStrikesRemaining <= 0) {
      if (this.stormActive && !this.isGameOver) {
        this.stormActive = false;
        sounds.playCrowdCheer();
        this.score += 1000;
        this.showFloatingText(this.player.x, this.player.y - 70, '⚡ STORM SURVIVED! +1000 ⚡', '#22c55e', '24px');
        this.updateHUDText();
      }
      return;
    }

    this.stormStrikesRemaining--;

    // Strike position ahead of player
    const strikeX = this.player.x + Phaser.Math.Between(340, 480);
    const midY = (this.ceilingY + this.floorY) / 2;

    // 1. Red warning targeting laser line
    const warningBeam = this.add.graphics().setDepth(18);
    warningBeam.lineStyle(4, 0xef4444, 0.7);
    warningBeam.beginPath();
    warningBeam.moveTo(strikeX, this.ceilingY);
    warningBeam.lineTo(strikeX, this.floorY);
    warningBeam.stroke();

    this.tweens.add({
      targets: warningBeam,
      alpha: 0.2,
      duration: 180,
      yoyo: true,
      repeat: 3,
      onComplete: () => {
        if (warningBeam && warningBeam.active) warningBeam.destroy();
        if (this.sys && this.scene && !this.isGameOver && !this.isLevelCompleted) {
          this.spawnStormLightningBolt(strikeX, midY);
        }
      }
    });
  }

  spawnStormLightningBolt(strikeX, midY) {
    if (!this.sys || !this.scene || this.isGameOver || this.isLevelCompleted) return;

    sounds.playThunder();
    this.cameras.main.shake(160, 0.012);

    // Hazard lightning bolt column
    const boltHazard = this.hazards.create(strikeX, midY, 'hazard_laser');
    if (boltHazard) {
      boltHazard.setDisplaySize(38, this.floorY - this.ceilingY - 20);
      boltHazard.setSize(28, this.floorY - this.ceilingY - 25);
      boltHazard.setTint(0xfacc15);
      boltHazard.setDepth(20);
    }

    this.lightningEmitter.explode(35, strikeX, midY);
    this.sparkEmitter.explode(25, strikeX, midY);

    this.time.delayedCall(450, () => {
      if (boltHazard && boltHazard.active) {
        boltHazard.destroy();
      }
      if (this.sys && this.scene && !this.isGameOver && !this.isLevelCompleted) {
        this.time.delayedCall(1100, () => this.scheduleNextStormStrike());
      }
    });
  }

  // =========================================================================
  // STAGE COMPLETION
  // =========================================================================
  handleStageComplete() {
    if (this.isLevelCompleted || this.isGameOver) return;
    this.isLevelCompleted = true;

    sounds.music.stop();
    sounds.playRockChord();

    this.cameras.main.flash(400, 250, 204, 21);
    this.sparkEmitter.explode(60, this.player.x, this.player.y);
    this.noteEmitter.explode(40, this.player.x, this.player.y);
    this.player.setVelocity(0, 0);
    this.player.play('guitar');

    // Metagame Bank Deposit (deposit vinyls earned during this stage)
    const stageVinyls = Math.max(0, this.vinylsCount - (this.carryOverVinyls || 0));
    let bankGain = stageVinyls;
    if (this.hasMidas) bankGain *= 2;
    const newBankTotal = progression.addBankVinyls(bankGain);

    const currentHigh = parseInt(localStorage.getItem('zelvis_highscore') || '0', 10);
    if (this.score > currentHigh) {
      localStorage.setItem('zelvis_highscore', this.score.toString());
    }

    this.time.delayedCall(800, () => {
      this.scene.start('VictoryScene', {
        level: this.currentLevel,
        score: this.score,
        vinyls: this.vinylsCount,
        bankGain,
        bankTotal: newBankTotal
      });
    });
  }

  // =========================================================================
  // HUD (Head-Up Display)
  // =========================================================================
  createHUD(width) {
    this.hudContainer = this.add.container(0, 0).setScrollFactor(0).setDepth(80);

    // Frosted glass header bar
    const bar = this.add.graphics();
    bar.fillStyle(0x090d16, 0.90);
    bar.fillRect(0, 0, width, 68);
    bar.lineStyle(2, this.cfg.hexColor, 0.85);
    bar.beginPath();
    bar.moveTo(0, 68);
    bar.lineTo(width, 68);
    bar.stroke();

    // Subtle stage color glow along top of HUD
    bar.fillStyle(this.cfg.hexColor, 0.15);
    bar.fillRect(0, 0, width, 3);

    // Stage indicator pill badge
    const stageBadgeBg = this.add.graphics();
    stageBadgeBg.fillStyle(0x1e293b, 0.85);
    stageBadgeBg.fillRoundedRect(12, 6, 175, 20, 6);
    stageBadgeBg.lineStyle(1.5, this.cfg.hexColor, 0.8);
    stageBadgeBg.strokeRoundedRect(12, 6, 175, 20, 6);

    const stageTitle = this.cfg.title;
    this.txtStage = this.add.text(18, 9, stageTitle, {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '12.5px',
      color: this.cfg.color
    });

    // Score text
    this.txtScore = this.add.text(14, 29, `SCORE: ${this.score}`, {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '18px',
      color: '#fde047'
    });

    // Combo multiplier badge
    this.comboBadge = this.add.text(14, 48, '🔥 x1', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      color: '#cbd5e1',
      fontStyle: 'bold'
    });

    // Center Display: Lives & Vinyls
    this.txtLives = this.add.text(width / 2 - 45, 8, '❤️❤️❤️', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '15px'
    });

    this.txtVinyl = this.add.text(width / 2 - 45, 28, `📀 ${this.vinylsCount}`, {
      fontFamily: 'Arial, sans-serif',
      fontSize: '15px',
      color: '#ffffff',
      fontStyle: 'bold'
    });

    // Shield status badge
    this.shieldBadge = this.add.text(width / 2 - 45, 48, this.hasShield ? '🛡️ SHIELD' : '', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '11px',
      color: '#38bdf8',
      fontStyle: 'bold'
    });

    // Gravity Indicator Badge
    this.gravityBadge = this.add.text(width - 55, 9, '⬇ NORMAL', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      color: '#38bdf8',
      fontStyle: 'bold',
      backgroundColor: '#1e293b',
      padding: { x: 8, y: 3 }
    }).setOrigin(1, 0);

    // Audio Mute/Unmute Toggle
    this.soundToggle = this.add.text(width - 12, 9, sounds.isMuted ? '🔇' : '🔊', {
      fontSize: '17px',
      backgroundColor: '#1e293b',
      padding: { x: 5, y: 3 }
    }).setOrigin(1, 0).setInteractive({ useHandCursor: true });

    this.soundToggle.on('pointerdown', () => {
      sounds.isMuted = !sounds.isMuted;
      sounds.music.setMuted(sounds.isMuted);
      this.soundToggle.setText(sounds.isMuted ? '🔇' : '🔊');
    });

    // Overdrive Gauge Bar (along bottom of HUD header)
    this.overdriveBar = this.add.graphics();
    this.txtOverdrive = this.add.text(width - 55, 40, '⚡ OVERDRIVE 0%', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      color: '#facc15',
      fontStyle: 'bold'
    }).setOrigin(1, 0);

    this.hudContainer.add([
      bar,
      stageBadgeBg,
      this.txtStage,
      this.txtScore,
      this.comboBadge,
      this.txtLives,
      this.txtVinyl,
      this.shieldBadge,
      this.gravityBadge,
      this.soundToggle,
      this.overdriveBar,
      this.txtOverdrive
    ]);

    this.updateHUDText();
  }

  updateGravityHUD() {
    if (this.gravityBadge) {
      if (this.isGravityInverted) {
        this.gravityBadge.setText('⬆️ ANTI-GRAV');
        this.gravityBadge.setColor('#f43f5e');
      } else {
        this.gravityBadge.setText('⬇️ NORMAL');
        this.gravityBadge.setColor('#38bdf8');
      }
    }
  }

  updateHUDText() {
    if (this.txtLives && this.lastLives !== this.lives) {
      this.lastLives = this.lives;
      const hearts = '❤️'.repeat(Math.max(0, this.lives)) + '🖤'.repeat(Math.max(0, this.maxLives - this.lives));
      this.txtLives.setText(hearts);
    }
    if (this.txtScore && this.lastScore !== this.score) {
      this.lastScore = this.score;
      this.txtScore.setText(`SCORE: ${this.score}`);
    }
    if (this.txtVinyl && this.lastVinyls !== this.vinylsCount) {
      this.lastVinyls = this.vinylsCount;
      this.txtVinyl.setText(`📀 ${this.vinylsCount}`);
    }

    // Update Combo Badge
    if (this.comboBadge && this.lastComboVal !== this.comboMultiplier) {
      this.lastComboVal = this.comboMultiplier;
      if (this.comboMultiplier > 1) {
        this.comboBadge.setText(`🔥 x${this.comboMultiplier} COMBO!`);
        this.comboBadge.setColor(this.comboMultiplier >= 5 ? '#f43f5e' : '#f59e0b');
      } else {
        this.comboBadge.setText('🔥 x1');
        this.comboBadge.setColor('#94a3b8');
      }
    }

    // Update Shield Badge
    if (this.shieldBadge && this.lastShieldState !== this.hasShield) {
      this.lastShieldState = this.hasShield;
      this.shieldBadge.setText(this.hasShield ? '🛡️ SHIELD' : '');
    }

    // Update Overdrive Bar
    const currentOD = Math.floor(this.overdriveMeter);
    if (this.overdriveBar && (this.lastODVal !== currentOD || this.lastODActive !== this.isOverdrive)) {
      this.lastODVal = currentOD;
      this.lastODActive = this.isOverdrive;
      const { width } = this.scale;
      this.overdriveBar.clear();

      // Background track
      this.overdriveBar.fillStyle(0x1e293b, 0.9);
      this.overdriveBar.fillRect(0, 65, width, 3);

      // Fill bar
      const fillW = Math.max(0, (width * (this.overdriveMeter / 100)));
      const fillColor = this.isOverdrive ? 0xf43f5e : 0xfacc15;
      this.overdriveBar.fillStyle(fillColor, 1);
      this.overdriveBar.fillRect(0, 65, fillW, 3);

      if (this.txtOverdrive) {
        if (this.isOverdrive) {
          this.txtOverdrive.setText('⚡ OVERDRIVE 3X! ⚡');
          this.txtOverdrive.setColor('#f43f5e');
        } else {
          this.txtOverdrive.setText(`⚡ OVERDRIVE ${currentOD}%`);
          this.txtOverdrive.setColor('#facc15');
        }
      }
    }
  }

  // =========================================================================
  // GAME OVER HANDLING
  // =========================================================================
  handleGameOver() {
    if (this.isGameOver || this.isLevelCompleted) return;
    this.isGameOver = true;

    sounds.music.stop();
    sounds.playCrash();
    this.cameras.main.shake(300, 0.02);
    this.cameras.main.flash(300, 239, 68, 68);

    this.sparkEmitter.explode(40, this.player.x, this.player.y);
    this.player.setVelocity(0, 0);
    this.player.setTint(0xff0000);

    // Metagame Bank Deposit (deposit vinyls earned during this stage)
    const stageVinyls = Math.max(0, this.vinylsCount - (this.carryOverVinyls || 0));
    let bankGain = stageVinyls;
    if (this.hasMidas) bankGain *= 2;
    const newBankTotal = progression.addBankVinyls(bankGain);

    const currentHigh = parseInt(localStorage.getItem('zelvis_highscore') || '0', 10);
    if (this.score > currentHigh) {
      localStorage.setItem('zelvis_highscore', this.score.toString());
    }

    this.time.delayedCall(700, () => {
      this.scene.start('GameOverScene', {
        level: this.currentLevel,
        score: this.score,
        vinyls: this.vinylsCount,
        bankGain,
        bankTotal: newBankTotal
      });
    });
  }

  // =========================================================================
  // MAIN UPDATE LOOP (60 FPS)
  // =========================================================================
  update(time, delta) {
    if (this.isGameOver || this.isLevelCompleted) return;

    // Update touch/virtual controls every frame
    if (this.virtualControls) {
      this.virtualControls.update();
    }

    // 1. CHECK GROUNDED STATE
    const onFloor = !this.isGravityInverted && (this.player.body.blocked.down || this.player.body.touching.down);
    const onCeiling = this.isGravityInverted && (this.player.body.blocked.up || this.player.body.touching.up);
    const isGrounded = onFloor || onCeiling;

    // Contact surface Y for friction particles
    const contactY = this.isGravityInverted ? this.player.y - 32 : this.player.y + 38;

    // 2. SLIDE & SKID LOGIC
    const slideWanted = this.virtualControls.isSlideRequested();
    const inputAxis = this.virtualControls.getHorizontalInput();

    // Trigger Slide
    if (isGrounded && slideWanted) {
      if (!this.isSliding) {
        this.isSliding = true;
        this.slideTimer = 550; // ms slide burst
        sounds.playSlide();

        // Track Mission: Slide Shredder
        this.slideCount++;
        if (this.slideCount >= 4) {
          if (progression.claimMission('slide_master')) {
            this.showFloatingText(this.player.x, this.player.y - 50, '🏆 MISSION CLEAR: SLIDE MASTER!', '#22c55e', '20px');
          }
        }

        // Low-profile hitbox allows ducking under hazards!
        this.player.setSize(120, 120);
        this.player.setOffset(68, this.isGravityInverted ? 25 : 120);
      }
    }

    if (this.isSliding) {
      this.slideTimer -= delta;
      // High slide velocity forward!
      this.player.setVelocityX(this.AUTO_FORWARD_SPEED + 180);
      this.player.play('slide', true);

      // Friction smoke & sparks under knees
      if (Math.random() < 0.6) {
        this.smokeEmitter.explode(2, this.player.x - 14, contactY);
      }
      if (Math.random() < 0.3) {
        this.sparkEmitter.explode(2, this.player.x - 14, contactY);
      }

      if (this.slideTimer <= 0 || (!slideWanted && this.slideTimer < 320)) {
        this.isSliding = false;
        // Restore standard upright hitbox
        this.player.setSize(80, 215);
        this.player.setOffset(88, 25);
      }
    } else {
      // Restore standard upright hitbox if not sliding
      if (this.player.body.height < 150) {
        this.player.setSize(80, 215);
        this.player.setOffset(88, 25);
      }

      // Check for Braking / Skid (pressing left while rushing forward)
      const isBraking = isGrounded && inputAxis < 0;

      if (isBraking) {
        this.isSkidding = true;
        // Slow down forward velocity sharply with braking friction
        this.player.setVelocityX(Math.max(40, this.AUTO_FORWARD_SPEED - 180));
        this.player.play('skid', true);

        // Skid screech particles and audio
        if (Math.random() < 0.5) {
          this.smokeEmitter.explode(2, this.player.x + 8, contactY);
          this.sparkEmitter.explode(2, this.player.x + 8, contactY);
        }

        if (this.skidSoundCooldown <= 0) {
          sounds.playSkid();
          this.skidSoundCooldown = 400; // ms
        }
      } else {
        this.isSkidding = false;
        const targetVelocityX = this.AUTO_FORWARD_SPEED + (inputAxis * this.MOVE_SPEED);
        this.player.setVelocityX(targetVelocityX);

        if (isGrounded) {
          if (targetVelocityX > 50) {
            this.player.play('run', true);
            // Occasional sprint spark from heels
            if (Math.random() < 0.08) {
              this.sparkEmitter.explode(1, this.player.x - 18, contactY);
            }
          } else {
            this.player.play('idle', true);
          }
        } else {
          // Mid-air Anti-Gravity Pose
          this.player.play('flip', true);
        }
      }
    }

    if (this.skidSoundCooldown > 0) {
      this.skidSoundCooldown -= delta;
    }

    // 3. SHIELD FORCEFIELD TRACKING
    if (this.shieldSprite && this.shieldSprite.active) {
      this.shieldSprite.setPosition(this.player.x, this.player.y);
    }

    // 4. OVERDRIVE FRENZY TIMING & PARTICLES
    if (this.isOverdrive) {
      this.overdriveTimer -= delta;
      const maxTime = this.hasFuel ? 7000 : 5000;
      this.overdriveMeter = Math.max(0, (this.overdriveTimer / maxTime) * 100);

      // Electric lightning surge trail
      if (Math.random() < 0.45) {
        this.lightningEmitter.explode(3, this.player.x + Phaser.Math.Between(-15, 15), this.player.y + Phaser.Math.Between(-25, 25));
      }

      if (this.overdriveTimer <= 0) {
        this.isOverdrive = false;
        this.overdriveMeter = 0;
        this.showFloatingText(this.player.x, this.player.y - 45, 'OVERDRIVE COOLED', '#94a3b8', '16px');
        this.updateHUDText();
      }
    }

    // 5. COMBO MULTIPLIER TIMER
    if (this.comboTimer > 0) {
      this.comboTimer -= delta;
      if (this.comboTimer <= 0) {
        this.comboMultiplier = 1;
        this.updateHUDText();
      }
    }

    // 6. MAGNETIC VACUUM FOR VINYLS & BOLTS
    const magnetRadius = this.isOverdrive ? 420 : (this.hasMagnet ? 240 : 0);
    if (magnetRadius > 0) {
      this.collectibles.getChildren().forEach(item => {
        if (!item.active) return;
        const dist = Phaser.Math.Distance.Between(this.player.x, this.player.y, item.x, item.y);
        if (dist <= magnetRadius) {
          const angle = Phaser.Math.Angle.Between(item.x, item.y, this.player.x, this.player.y);
          const pullSpeed = this.isOverdrive ? 560 : 420;
          item.x += Math.cos(angle) * pullSpeed * (delta / 1000);
          item.y += Math.sin(angle) * pullSpeed * (delta / 1000);
        }
      });
    }

    // 7. CLOSE-CALL / GRAZE RISK SYSTEM
    this.hazards.getChildren().forEach(hazard => {
      if (!hazard.active || hazard.grazed) return;
      const dx = hazard.x - this.player.x;
      const dy = Math.abs(hazard.y - this.player.y);

      // Danger zone graze (near-miss within 18..68px)
      if (dx > -25 && dx < 45 && dy > 18 && dy < 68) {
        hazard.grazed = true;
        this.closeCallCount++;

        // Track Mission: Danger Close
        if (this.closeCallCount >= 3) {
          if (progression.claimMission('close_call_hero')) {
            this.showFloatingText(this.player.x, this.player.y - 65, '🏆 MISSION CLEAR: DANGER CLOSE!', '#22c55e', '20px');
          }
        }

        this.increaseCombo();
        const grazeBonus = 150 * this.comboMultiplier;
        this.score += grazeBonus;

        const charge = this.hasFuel ? 15 : 10;
        this.overdriveMeter = Math.min(100, this.overdriveMeter + charge);

        sounds.playCloseCall();
        this.sparkEmitter.explode(12, hazard.x, hazard.y);
        this.showFloatingText(this.player.x + 25, this.player.y - 35, `⚡ CLOSE CALL! x${this.comboMultiplier}`, '#fbbf24', '18px');

        if (this.overdriveMeter >= 100 && !this.isOverdrive) {
          this.activateOverdrive();
        }
        this.updateHUDText();
      }
    });

    // 8. MID-STAGE ZEUS THUNDER STORM SURVIVAL EVENT TRIGGER
    if (this.player.x >= 1200 && !this.stormTriggered && this.player.x <= 2000) {
      this.startZeusThunderStorm();
    }

    // Update moving platforms safely
    this.movingPlatforms.getChildren().forEach(mp => {
      if (mp && mp.active && mp.body) {
        if (mp.y >= mp.maxY && mp.body.velocity.y > 0) {
          mp.body.setVelocityY(-mp.moveSpeed);
        } else if (mp.y <= mp.minY && mp.body.velocity.y < 0) {
          mp.body.setVelocityY(mp.moveSpeed);
        }
      }
    });

    // 9. SCORE INCREMENT (multiplied during Overdrive)
    this.distanceScoreAcc = (this.distanceScoreAcc || 0) + delta * (0.028 + (this.currentLevel * 0.006));
    if (this.distanceScoreAcc >= 1) {
      const addedPoints = Math.floor(this.distanceScoreAcc);
      this.distanceScoreAcc -= addedPoints;
      this.score += this.isOverdrive ? addedPoints * 3 : addedPoints;
      this.updateHUDText();
    }

    // 10. PITFALL RESCUE / DETECTION
    if (this.player.y > this.floorY + 70 || this.player.y < this.ceilingY - 70) {
      if (this.lives > 1) {
        this.takeDamage(null);
        // Teleport back to safe runway center
        this.player.y = (this.ceilingY + this.floorY) / 2;
        this.player.setVelocityY(0);
        this.isGravityInverted = false;
        this.physics.world.gravity.y = this.GRAVITY_STRENGTH;
        this.player.setFlipY(false);
      } else {
        this.handleGameOver();
        return;
      }
    }

    // 11. DYNAMIC CHUNK GENERATION
    if (this.player.x + 800 > this.lastGeneratedX) {
      this.generateChunk();
    }

    // 12. GARBAGE COLLECTION (Safe snapshot iteration)
    const cleanupX = this.player.x - 700;
    const cleanGroup = (group) => {
      if (!group) return;
      const children = [...group.getChildren()];
      for (let i = 0; i < children.length; i++) {
        const item = children[i];
        if (item && item.active && item.x < cleanupX) {
          item.destroy();
        }
      }
    };
    cleanGroup(this.platforms);
    cleanGroup(this.movingPlatforms);
    cleanGroup(this.hazards);
    cleanGroup(this.collectibles);
  }

  shutdown() {
    sounds.music.stop();
    this.time.removeAllEvents();
    this.tweens.killAll();
    if (this.virtualControls) {
      this.virtualControls.destroy();
      this.virtualControls = null;
    }
  }
}
